// extracted by mini-css-extract-plugin
export var highlightedtextinner = "SectionHighlightedTextBlock-module--highlightedtextinner--bf2b9";
export var highlightedtextsectionbreak = "SectionHighlightedTextBlock-module--highlightedtextsectionbreak--ed4f8";
export var textarea = "SectionHighlightedTextBlock-module--textarea--7490e";